

import { Component, Prop, Vue } from "vue-property-decorator"
import { CaseDetails } from "@/types"

@Component({})
export default class CaseSubheader extends Vue {
	@Prop()
	public currentCase!: CaseDetails | null
}
